import Oops from '../../views/Oops';
import Success from '../../views/Success';

export default [
    {
        path: '/oops/:messageShortCode',
        name: 'oops',
        component: Oops
    },
    {
        path: '/success/:messageShortCode',
        name: 'success',
        component: Success
    }
];